/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_None_YetInputs */



/**
* | output |
* | --- |
* | "No leagues have been created yet." |
*
* @param {League_None_YetInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_none_yet = /** @type {((inputs?: League_None_YetInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_None_YetInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ligue n'a encore été créée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aún no se han creado ligas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma liga foi criada ainda.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun campionato è stato ancora creato.")
	return /** @type {LocalizedString} */ ("No leagues have been created yet.")
});